import { createStyles, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useRefresh,
  useShowContext,
} from 'react-admin'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import Button from '../../../common/customized-mui-components/Button'
import { OfflineServerDto } from '../../../../core/dto/device/offline-servers/offline-server.dto'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { ConfirmDialog } from '../../../common/ConfirmDialog'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

export const OfflineServerRemoveCredentialsButton = () => {
  const { record: server, loading } = useShowContext<OfflineServerDto>()
  const classes = useStyles()
  const [removeCredentialsDialogOpen, setRemoveCredentialsDialogOpen] =
    useState(false)
  const hasAuthority = useHasAuthority()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()
  const notify = useNotify()

  const handleRemoveCredentials = async () => {
    setRemoveCredentialsDialogOpen(false)
    await mutate(
      {
        type: sanitizeFetchType('removeCredentials'),
        resource: ResourceName.OFFLINE_SERVERS,
        payload: {
          offlineServerId: server?.id,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    refresh()
  }

  const handleRemoveCredentialsDialog = () => {
    setRemoveCredentialsDialogOpen(true)
  }

  return (
    <>
      <ConfirmDialog
        open={removeCredentialsDialogOpen}
        confirm={handleRemoveCredentials}
        source="setCredentials"
        cancel={() => setRemoveCredentialsDialogOpen(false)}
        action="remove"
        resource={ResourceName.OFFLINE_SERVERS}
      />
      <Button
        variant="contained"
        onClick={handleRemoveCredentialsDialog}
        color="primary"
        className={classes.button}
        label="resources.offline-servers.actions.removeCredentials"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.OFFLINE_SERVERS_MANAGE_CREDENTIALS_BUTTON) ||
          loading ||
          mutationLoading
        }
      />
    </>
  )
}
